import { createAction, props } from '@ngrx/store';
import { User } from '../user.entity';

export const setActiveUser = createAction(
  '[User Profile Page] Set Active User',
  props<{ user: User }>()
);

export const upsertUser = createAction(
  '[User Profile Page] Upsert User',
  props<{ user: User; callback: () => void }>()
);

export const clearActiveUser = createAction(
  '[User Profile Page] Clear Active User'
);
